import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles(() => ({
    title: {
        padding: '0 20px',
    },
    root: {
        display: 'flex', 
        justifyContent: 'space-between',
        width: 'calc(100% - 90px)', 
        borderRadius: '4px',
        boxShadow: '0 1px 2px 0 rgba(0,0,0,.5), inset 0 1px 0 0 #31406d',
        padding: '16px',
        position: 'relative',
        margin: 20,
        // height: 400,
        background: 'rgb(27, 32, 57)'
    },
    search: {
        height: '32px',
        paddingLeft: '8px',
        paddingRight: '8px',
        fontSize: '16px',
        width: '250px',
        border: 0,
        borderRadius: 15,
        background: '#1c2542',
        color: '#fff',
        outline: 'none',
        boxShadow: '0 1px 0 0 hsla(0,0%,100%,.15), inset 0 1px 0 0 rgba(0,0,0,.15)',
    },
    group: {
        borderBottom: '1px solid rgba(255,255,255,0.15)',
        margin: 0,
        padding: 5,
        color: '#fff',
        cursor: 'pointer',
        display: 'flex',
         alignItems: 'center', 
         justifyContent: 'space-between',
        '&:hover': {
            background: 'rgba(255,255,255,0.15)',
        }
    },
    btn: {
        display: 'inline-block',
        padding: '5px 12px',
        fontSize: '14px',
        color: '#00a3f9',
        background: 'none',
        border: '1px solid #00a3f9',
        borderRadius: 12,
        marginLeft: 35,
        cursor: 'pointer',
        '&:hover': {
            borderColor: 'rgba(255,255,255,.15)',
            color: '#ffce01'
        }
    },
    wrapSearch: {
        width: '29%', 
        marginRight: 20
    },
    divider: {
        display: 'flex', 
        width: '1px', 
        background: '#ccc',
        borderRadius: 12
    },
    searchCashier: {
        width: '69%', 
        paddingLeft: 30
    },
    mt12: {
        marginTop: 12
    }
}))

export {
    useStyles,
}